import { Component, OnInit } from '@angular/core';
import {ResetPasswordComponent} from "@spartacus/user/profile/components";
import { SpinnerComponent, FormErrorsComponent } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-reset-password',
    templateUrl: './efa-reset-password.component.html',
    imports: [SpinnerComponent, FormsModule, ReactiveFormsModule, FormErrorsComponent, AsyncPipe, TranslatePipe]
})
export class EfaResetPasswordComponent extends ResetPasswordComponent {

}
